import theme from '../theme'

export interface BpByMeasureTypeItem {
	[key: string]: string
}

export const BP_BY_MEASURE_TYPE: Array<BpByMeasureTypeItem> = [
	{
		id: 'low',
		label: 'Low',
		light: theme.palette.gold.light,
		main: theme.palette.gold.main,
	},

	{
		id: 'normal',
		label: 'Normal',
		light: theme.palette.sushi.light,
		main: theme.palette.sushi.main,
	},

	{
		id: 'elevated',
		label: 'Elevated',
		light: theme.palette.steelBlue.light,
		main: theme.palette.steelBlue.main,
	},

	{
		id: 'high_stg_1',
		label: 'Stage 1',
		light: theme.palette.trueV.light,
		main: theme.palette.trueV.main,
	},

	{
		id: 'high_stg_2',
		label: 'Stage 2',
		light: theme.palette.camelot.light,
		main: theme.palette.camelot.main,
	},

	{
		id: 'hyper_bp',
		label: 'Hyper',
		light: theme.palette.temptress.light,
		main: theme.palette.temptress.main,
	},
]
